import {
    formatEnumLabel,
    translateWithFallback,
} from '@/i18n/translationUtils';

export const AUDIT_GAP_STATUSES = [
    'OPEN',
    'ACTIONED',
    'RESOLVED',
    'INVALIDATED',
];

const AUDIT_GAP_STATUS_LABEL_KEYS = {
    OPEN: 'gaps.shared.statuses.open',
    ACTIONED: 'gaps.shared.statuses.actioned',
    RESOLVED: 'gaps.shared.statuses.resolved',
    INVALIDATED: 'gaps.shared.statuses.invalidated',
};

export function normalizeAuditGapStatus(status) {
    return String(status ?? '')
        .trim()
        .toUpperCase();
}

export function getAuditGapStatusLabel(status, translateFn = null) {
    const normalized = normalizeAuditGapStatus(status);
    if (AUDIT_GAP_STATUS_LABEL_KEYS[normalized]) {
        return translateWithFallback(
            translateFn,
            AUDIT_GAP_STATUS_LABEL_KEYS[normalized],
            formatEnumLabel(normalized)
        );
    }
    return (
        normalized ||
        translateWithFallback(
            translateFn,
            'common.fallbacks.unknown',
            'Unknown'
        )
    );
}

export function getAuditGapStatusVariant(status) {
    const normalized = normalizeAuditGapStatus(status);
    if (normalized === 'ACTIONED') return 'primary';
    if (normalized === 'RESOLVED') return 'success';
    if (normalized === 'INVALIDATED') return 'dark';
    return 'neutral';
}

export function getAuditGapStatusOptions(
    statuses = AUDIT_GAP_STATUSES,
    translateFn = null
) {
    return statuses.map((status) => ({
        value: status,
        label: getAuditGapStatusLabel(status, translateFn),
    }));
}
